import { useDebounce } from "use-debounce";
import { DatePicker, message, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";

import { controller } from "../TreatmentPlans/controller";

import search from "../../assets/icons/search-normal.svg";
import calendar from "../../assets/icons/calendar.png";

export default function InsuranceFilters({ filters, setFilters, allPatients, allProcedures }) {
  const [isFilteringProcedures, setIsFilteringProcedures] = useState(false);
  const [procedureSearch, setProcedureSearch] = useState("");
  const [dropdownProceduresOptions, setDropdownProceduressOptions] = useState([]);
  const [procedureSearchValue] = useDebounce(procedureSearch, 1000);

  const patientOptions = allPatients.map((patient) => ({
    value: patient.id,
    label: `${patient.first_name} ${patient.last_name}`,
  }));

  // const procedureOptions = allProcedures.map((procedure) => ({
  //   value: procedure.id,
  //   label: `${procedure.procedure_code} - ${procedure.name}`,
  // }));

  useEffect(function () {
    const procedureOptions = allProcedures.map((procedure) => ({
      value: procedure.id,
      label: `${procedure.procedure_code} ${procedure.procedure_code_description ? `- ${procedure.procedure_code_description}` : ""}`,
    }));

    setDropdownProceduressOptions(procedureOptions);
  }, []);

  const handleChangeProcedureSearch = async (input, option) => {
    setProcedureSearch(input); // Update the search input state
  };

  // Effect to handle debounced procedure search
  useEffect(() => {
    const fetchProcedures = async () => {
      let procedureCode = "";
      let procedureDescription = "";

      // Check if input is valid
      if (typeof procedureSearchValue !== "string" || !procedureSearchValue) {
        procedureDescription = procedureSearchValue || "";
      } else {
        // Extract numbers using regex
        const numberMatch = procedureSearchValue.match(/\d+/g);

        if (numberMatch) {
          // Join all number sequences for procedureCode
          procedureCode = numberMatch.join("");
          // Remove all numbers from input to get description
          procedureDescription = procedureSearchValue.replace(/\d+/g, "").trim();
          // Clean up any leading/trailing hyphens or spaces
          procedureDescription = procedureDescription.replace(/^-+|-+$/g, "").trim();
        } else {
          // If no numbers, entire input is description
          procedureDescription = procedureSearchValue.trim();
        }
      }

      try {
        setIsFilteringProcedures(true);
        const response = await controller.getProcedure(0, { procedureCode, procedureDescription });

        if (response.status < 250) {
          const data = await response.json;
          const procedureOptions = data.map((procedure) => ({
            value: procedure.id,
            label: `${procedure.procedure_code} ${procedure.procedure_code_description ? `- ${procedure.procedure_code_description}` : ""}`,
          }));

          setDropdownProceduressOptions(procedureOptions);
        }
      } catch (err) {
        message.error("Something went wrong while filtering procedures");
        console.error(err);
      } finally {
        setIsFilteringProcedures(false);
      }
    };

    fetchProcedures();
  }, [procedureSearchValue]);

  useEffect(
    function () {
      if (isFilteringProcedures) {
        setDropdownProceduressOptions([
          {
            value: "loading",
            label: <Spin />,
          },
        ]);
      }
    },
    [isFilteringProcedures]
  );

  return (
    <>
      <p style={{ fontSize: 20, marginBottom: 20 }}>Advanced Filters</p>

      <div style={{ width: "100%" }} className="insurance-filters-container">
        <div className="insurance-filter-row" style={{ gap: 20 }}>
          <div className="predetermination-filters-inputs">
            <label className="predetermination-filter-inputs-label">From: </label>

            <DatePicker
              onChange={(date, dateString) => setFilters({ ...filters, submission_date_from: dateString })}
              suffixIcon={<img src={calendar} alt="calendar" />}
              style={{ height: 42, border: "1px solid #6B43B5" }}
              format="YYYY-MM-DD"
              dateFormat="YYYY-MM-DD"
              className="insurance-filter-input"
            />
          </div>

          <div className="predetermination-filters-inputs">
            <label className="predetermination-filter-inputs-label">To: </label>

            <DatePicker
              onChange={(date, dateString) => setFilters({ ...filters, submission_date_to: dateString })}
              suffixIcon={<img src={calendar} alt="calendar" />}
              style={{ height: 42, border: "1px solid #6B43B5" }}
              format="YYYY-MM-DD"
              dateFormat="YYYY-MM-DD"
              className="insurance-filter-input"
            />
          </div>
        </div>

        <div className="insurance-filter-row" style={{ gap: 20 }}>
          <div className="predetermination-filters-inputs" style={{ width: "100%" }}>
            <label className="predetermination-filter-inputs-label">Patients</label>

            <Select
              showSearch
              mode="multiple"
              placeholder="Search Patient"
              optionFilterProp="label"
              options={patientOptions}
              className="insurance-filter-input"
              value={filters.patient_ids || undefined}
              prefix={<img style={{ width: 20 }} src={search} alt="arrow-down" />}
              onChange={(value) => setFilters((prevFilters) => ({ ...prevFilters, patient_ids: value }))}
            />
          </div>

          <div className="predetermination-filters-inputs" style={{ width: "100%" }}>
            <label className="predetermination-filter-inputs-label">Procedures</label>
            <Select
              showSearch
              mode="multiple"
              placeholder="Search Procedure"
              optionFilterProp="label"
              filterOption={(input, option) => handleChangeProcedureSearch(input, option)}
              options={dropdownProceduresOptions}
              className="insurance-filter-input"
              value={filters.procedure_ids || undefined}
              prefix={<img style={{ width: 20 }} src={search} alt="arrow-down" />}
              onChange={(value) => setFilters((prevFilters) => ({ ...prevFilters, procedure_ids: value }))}
            />
          </div>
        </div>
      </div>
    </>
  );
}
